import React from "react"; // <OutsideClick> uses findDOmNode which is deprecated

var useOutsideClick = function useOutsideClick(cb, node) {
  React.useEffect(function () {
    if (!node) return;

    var handleClick = function handleClick(e) {
      // inside click
      if (node.contains(e.target)) {
        return;
      }

      cb();
    };

    document.addEventListener("mousedown", handleClick, {
      capture: true
    });
    return function () {
      document.removeEventListener("mousedown", handleClick, {
        capture: true
      });
    };
  }, [node, cb]);
};

export default useOutsideClick;